import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "./app";
import api from "./api";
import API_URL from "../config/ApiUrl";

const WebHookSlice = createSlice({
    name: 'WebHook',
    initialState: {},
    reducers: {}
})
export const getWebHookList = (payload?: any): AppThunk<any> => async () => {
    try {
        const resp = await api.post(API_URL.WEB_HOOK.LIST, payload)
        return Promise.resolve(resp.data)
    } catch (error: any) {
        return Promise.reject(error.data)
    }
}
export const detailsWebhook= (payload?: any): AppThunk<any> => async () => {
    try {
        const resp = await api.post(API_URL.WEB_HOOK.DETAILS, payload)
        return Promise.resolve(resp.data)
    } catch (error: any) {
        return Promise.reject(error.data)
    }
}
export const deleteWebhookData = (payload?: any): AppThunk<any> => async () => {
    try {
        const response = await api.post(API_URL.WEB_HOOK.DELETE, payload);
        return Promise.resolve(response.data);
    } catch (error: any) {
        return Promise.reject(error.data);
    }
};
export default WebHookSlice.reducer